import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Message, SelectItem } from "primeng/components/common/api";
import { AppConstants } from "../core/app.constants";
import { AuthAccessProvider } from "../core/core.auth";
import { BaseComponent, Offer, UserContext, UserInfo, Statistica, Attivita } from "../core/core.component";
import { MessageProvider } from "../service/message.service";
import { BusyProvider } from "../service/busy.service";
import { UserService } from "../service/user.service";
import { OfferService } from "app/service/offers.service";
import { StatisticheService } from "app/service/statistiche.service";
import { ReportService } from 'app/service/report.service';
import * as FileSaver from 'file-saver';

@Component({
	selector: "app-statistiche",
	templateUrl: "./statistiche.component.html",
	styleUrls: ["./statistiche.component.css"],
})
export class StatisticheComponent extends BaseComponent implements OnInit {
	statistiche: Statistica[] = [];
	filteredStatistiche: Statistica[] = [];
	attivita:Attivita[]=[];
	tipologiaAttivita: string = null; // tipologia della commessa del dettaglio attivita', determina le colonne
	filterTipologia: any[] = ['P', 'K'];
	filterCliente: string = null;
	tipologiaOptions = [
		{ label: 'Time & Material', value: 'B' },
		{ label: 'Turnkey', value: 'K' },
		{ label: 'Plafond', value: 'P' },
		{ label: 'Application Maintenance', value: 'A' }
	];
	filterRefOrder: string = null;
	statisticaSelected: Statistica = new Statistica;
	onlyActive: boolean = true;
	dtinizio:Date = null;
	dtfine:Date = null;
	showAttivita:boolean= false;

	userContext: UserContext;
	userInfo: UserInfo = new UserInfo();
	locale: any = AppConstants.ITA_CALENDAR_CONF;
	it: any = AppConstants.ITA_CALENDAR_CONF;

	loading: boolean = false;

	showFilter: boolean = false;

	msgs: Message[] = [];

	//Per autocompilazione filtro
	offers: Offer[] = [];
	reforder: string = null;
	commesseOptions: SelectItem[] = [];
	commesseFiltered: SelectItem[] = [];
	offersAttive: Offer[] = [];
	clientOptions: SelectItem[] = [];

	//per filtro delle attivita'
	monthSelected: number = null;
	yearSelected: number = null;
	months: SelectItem[] = [];
	years: SelectItem[] = [];

	sortField = 'refOrder';
	sortAsc = true;

	sortFieldAttivita = null;
	sortAscAttivita = true;

	constructor(
		protected authAccess: AuthAccessProvider,
		protected router: Router,
		protected messageProvider: MessageProvider,
		private userService: UserService,
		private offerService: OfferService,
		private statService: StatisticheService,
		private reportService: ReportService,
		private busyProvider: BusyProvider,
	) {
		super(authAccess, router, messageProvider);
		this.messageProvider.clearAll();
	}

	ngOnInit() {
		this.userContext = this.authAccess.getUserContext();
		if (this.userContext == null) {
			this.authAccess.invalidate();
		} else {
			this.loadOffers(false);	// Recupero tutte le offerte
			this.loadOffers(true);	// FIXME: pattern pessimo, doppia chiamata alle offerte 
			this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
				(result) => {
					this.userInfo = result;
				},
				(error) => {
					this.handleError(error);
				}
			);

			this.months = [
				{ label: 'Mese', value: null }
			];
			for (let i = 0; i < AppConstants.ITA_CALENDAR_CONF.monthNames.length; i++) {
				this.months.push({
					label: AppConstants.ITA_CALENDAR_CONF.monthNames[i],
					value: i + 1
				});
			}
			this.yearSelected = null;

			this.loadStatistiche();
		}
	}
	
	aggiorna(){
		this.loadStatistiche();
	}

	loadStatistiche() {
		this.buildClientOptions();
		this.statistiche = [];
		this.filteredStatistiche = [];
		this.loading = true;
		if(this.onlyActive){
			this.dtfine=null;
			this.dtinizio=null;
		}
		this.statService.getStatistiche(this.userContext.srmToken, this.filterRefOrder, this.onlyActive, this.filterTipologia, this.dtinizio, this.dtfine).subscribe(
			(result) => {
				if (result.statistiche) {
					try {
						const statistiche = result.statistiche;
						this.selectStatistica(this.statisticaSelected);

						if (!statistiche || statistiche.length === 0) {
							console.warn("Nessuna commessa trovata!");
							this.loading = false;
							return;
						}
						this.statistiche = statistiche;
						this.sort(this.sortField, this.sortAsc);
					} catch (e) {
						console.error("Errore nel parsing JSON:", e);
					}
				}
				this.loading = false;
			},
			(error) => {
				this.handleError(error);
				this.loading = false;
			}
		);
	}

	loadAttivita(event: MouseEvent,statistica: Statistica) {
		//event.stopPropagation();
		this.sortFieldAttivita = null;
		this.selectStatistica(statistica)
		this.attivita = [];
		this.tipologiaAttivita = null;
		this.showAttivita=true;
		this.statService.getAttivita(this.userContext.srmToken, statistica.refOrder).subscribe(
			(result) => {
				this.tipologiaAttivita = result.tipologia;
				if (result.attivita) {
					try {
						const attivita = result.attivita;

						if (!attivita || attivita.length === 0) {
							console.warn("Nessuna attivita trovata!");
							return;
						}
						
						this.attivita = attivita;
						this.sortAttivitaDefault();
						this.retrieveDistinctYears(attivita);
					} catch (e) {
						console.error("Errore nel parsing JSON:", e);
					}
				}
			},
			(error) => {
				this.handleError(error);
				this.loading = false;
			}
		);
	}

	loadOffers(onlyActive?: boolean) {
		this.offers = [];
		this.offerService.getOffers(this.userContext.srmToken, onlyActive).subscribe(
			(result) => {
				if (result.message) {
					try {
						const offers = JSON.parse(result.message);

						if (!offers || offers.length === 0) {
							console.warn("Nessuna commessa trovata!");
							return;
						}

						if (onlyActive) {
							this.offersAttive = offers;
						}
						else {
							this.offers = offers;
						}
						this.buildClientOptions();
					} catch (e) {
						console.error("Errore nel parsing JSON:", e);
					}
				}
			},
			(error) => {
				this.handleError(error);
				this.loading = false;
			}
		);
	}

	buildClientOptions() {
		const source = this.onlyActive ? this.offersAttive : this.offers;
		const uniqueClients = Array.from(new Set(
			source.filter(o => o.dscliente).map(o => o.dscliente)
		)).sort((a, b) => a.localeCompare(b, 'it', { sensitivity: 'base' }));
		this.clientOptions = [
			{ label: 'Tutti i clienti', value: null },
			...uniqueClients.map(c => ({ label: c, value: c }))
		];
	}

	applyClientFilter() {
		if (!this.filterCliente) {
			this.filteredStatistiche = this.statistiche.slice();
		} else {
			const source = this.onlyActive ? this.offersAttive : this.offers;
			const matchingRefOrders = new Set(
				source.filter(o => o.dscliente === this.filterCliente).map(o => o.reforder)
			);
			this.filteredStatistiche = this.statistiche.filter(s => matchingRefOrders.has(s.refOrder));
		}
	}

	selectStatistica(statistica: Statistica) {
		this.showAttivita=false;
		this.reforder = statistica.refOrder;
		this.statisticaSelected = statistica;
	}
	
	retrieveDistinctYears(attivitaList: Attivita[]): void {
		this.years = [];

		// Primo elemento fisso
		this.years.push({
			label: "Anno",
			value: null
		});

		if (!attivitaList || attivitaList.length === 0) {
			return;
		}

		const distinctYears = Array.from(
			new Set<number>(
				attivitaList
					.map(a => a.anno)
					.filter((a): a is number => a != null)
			)
		).sort((a, b) => a - b);

		distinctYears.forEach(year => {
			this.years.push({
				label: year.toString(),
				value: year
			});
		});
	}

	// lo stimato esiste solo per Plafond (DW_PLAFOND) e Turnkey (stima ticket TBG)
	showStimato(): boolean {
		return this.tipologiaAttivita === 'P' || this.tipologiaAttivita === 'K';
	}

	// per le Turnkey ogni riga e' relativa a un singolo ticket, senza anno/mese
	showAnnoMese(): boolean {
		return this.tipologiaAttivita !== 'K';
	}

	filterAttivita(attivitaList: Attivita[]) {
		if (!this.showAnnoMese()) {
			return attivitaList;
		}
		let result: Attivita[] = [];
		for (let i = 0; i < attivitaList.length; i++) {
			let current = attivitaList[i];
			if ((!this.yearSelected || current.anno == this.yearSelected) && (!this.monthSelected || current.mese == this.monthSelected)) {
				result.push(current);
			}
		}
		return result;
	}

	onSelectOffer(offer: any, isFilter: boolean) {
		this.filterTipologia= null;
		if(!isFilter){
			this.reforder = offer.value;
		}
		else{
			this.filterRefOrder = offer.value;
		}
	}
	
	onTipologiaChanged(event: any){
		this.filterRefOrder=null;
	}

	filterOffer(event, isFilter) {
		this.caricaSuggerimentiCommesse(isFilter);
		this.commesseFiltered = AppConstants.filterSuggestions(this.commesseOptions, event.query, item => [item.label, item.value]);
	}

	caricaSuggerimentiCommesse(isFilter: boolean) {
		let offerte = this.onlyActive ? this.offersAttive : this.offers;
		this.commesseOptions = offerte				//ordine alfabetico dei clienti nel dropdown
			.map(offer => ({
				label: offer.dsofferta,
				value: offer.reforder
			}))
			.sort((a, b) => a.label.localeCompare(b.label, 'it', { sensitivity: 'base' }));
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	removeFilter() {
		this.resetFilter();
		this.loadStatistiche();
		this.showFilter = false;
	}

	resetFilter() {
		this.filterRefOrder = null;
		this.filterTipologia = null;
		this.filterCliente = null;
		this.dtinizio = null;
		this.dtfine = null;
	}

	applyFilter() {
		this.loadStatistiche();
		this.showFilter = false;
	}

	calcolaGiornate(a: number, b: number) {
		if (a && b) {
			return a - b;
		}
		return null;
	}

	calcolaRisultato(a: number, b: number) {
		if (a != null && b != null) {
			return a - Math.round(b);
		}
		return null;
	}

	sort(field: string, asc?: boolean) {
		if (field === this.sortField && (typeof asc === 'undefined' || asc == !this.sortAsc)) {
			this.statistiche = this.statistiche.reverse();
			this.sortAsc = !this.sortAsc;
		} else {
			this.sortField = field;
			this.statistiche = this.statistiche.sort((a1, a2) => {
				var res = 0;
				if (this.sortField === 'refOrder') {
					res = this.compareStrings(a1.refOrder, a2.refOrder);
				} else if (this.sortField === 'descrizione') {
					res = this.compareStrings(a1.descrizione, a2.descrizione);
				} else if (this.sortField === 'giornateOfferta') {
					res = a1.giornate > a2.giornate ? 1 : -1;
				} else if (this.sortField === 'giornateStimate') {
					res = a1.giornateStimate > a2.giornateStimate ? 1 : -1;
				} else if (this.sortField === 'giornateEffettive') {
					res = a1.giornateEffettive > a2.giornateEffettive ? 1 : -1;
				} else if (this.sortField === 'rimanenza') {
					res = this.calcolaGiornate(a1.giornate,a1.giornateStimate) >  this.calcolaGiornate(a2.giornate,a2.giornateStimate) ? 1 : -1;
				} else if (this.sortField === 'risultato') {
					const r1 = this.calcolaRisultato(a1.giornateStimate || a1.giornate, a1.giornateEffettive);
					const r2 = this.calcolaRisultato(a2.giornateStimate || a2.giornate, a2.giornateEffettive);
					res = (r1 || 0) > (r2 || 0) ? 1 : -1;
				}
				return this.sortAsc ? res : -res;
			});
		}
		this.applyClientFilter();
	}

	sortAttivita(field: string, asc?: boolean) {
		if (field === this.sortFieldAttivita && (typeof asc === 'undefined' || asc == !this.sortAscAttivita)) {
			this.attivita = this.attivita.reverse();
			this.sortAscAttivita = !this.sortAscAttivita;
		} else {
			this.sortFieldAttivita = field;
			this.attivita = this.attivita.sort((a1, a2) => {
				var res = 0;
				if (this.sortFieldAttivita === 'ticket') {
					res = this.compareStrings(a1.ticket, a2.ticket);
				} else if (this.sortFieldAttivita === 'dsAttivita') {
					res = this.compareStrings(a1.dsAttivita, a2.dsAttivita);
				} else if (this.sortFieldAttivita === 'giorniStimati') {
					res = a1.giorniStimati > a2.giorniStimati ? 1 : -1;
				} else if (this.sortFieldAttivita === 'giorniEffettivi') {
					res = a1.giorniEffettivi > a2.giorniEffettivi ? 1 : -1;
				} else if (this.sortFieldAttivita === 'anno') {
					res = a1.anno > a2.anno ? 1 : -1;
				} else if (this.sortFieldAttivita === 'mese') {
					res = a1.mese > a2.mese ? 1 : -1;
				}
				return this.sortAscAttivita ? res : -res;
			});
		}
	}

	sortAttivitaDefault() {

		this.sortAscAttivita = false; 

		this.attivita = this.attivita.sort((a1, a2) => {

			let res = 0;

			if (a1.anno !== a2.anno) {
			res = a1.anno < a2.anno ? 1 : -1;
			}
			
			else if (a1.mese !== a2.mese) {
			res = a1.mese < a2.mese ? 1 : -1;
			}
			
			else {
			res = this.compareTicketDesc(a1.ticket, a2.ticket);
			}

			return res; 
		});
	}

	private compareTicketDesc(t1: string, t2: string): number {

		const r = /^([A-Z]{3})-(\d+)$/i;

		const m1 = t1.match(r);
		const m2 = t2.match(r);

		if (!m1 || !m2) {
		
			return t1 < t2 ? 1 : -1;
		}

		const text1 = m1[1].toUpperCase();
		const text2 = m2[1].toUpperCase();

		const num1 = Number(m1[2]);
		const num2 = Number(m2[2]);

		
		if (text1 !== text2) {
			return text1 < text2 ? 1 : -1;
		}

		
		if (num1 !== num2) {
			return num2 - num1;
		}

		return 0;
	}

	private compareStrings(s1: string, s2: string): number {
		 const a = (s1 || '').toLowerCase();
		const b = (s2 || '').toLowerCase();

		if (a === b) return 0;

		return a > b ? 1 : -1; 
	}

	onDateSelected(event:Date){
		this.onlyActive= false;
	}

	exportReportAttivita() {

        this.messageProvider.clearAll();
		this.busyProvider.showBusyIndicator();

        const parameters = new Object();

		parameters['mese'] = this.monthSelected;
		parameters['anno'] = this.yearSelected;
		parameters['reforder'] = this.reforder;

        this.reportService.exportReport(this.userContext.srmToken, 'com.netsitech.srm.excel.generator.StatsActivitiesReportGenerator', parameters).
        	subscribe(
				data => {
					this.busyProvider.hideBusyIndicator();
					let filename = "Report_Attività_Commessa_" + this.statisticaSelected.refOrder + "_" + new Date().getTime() + ".xlsx";
					this.download(data, filename);
				},
				error => {
					// nei report ci si aspetta un blob pertanto gli eventuali errori in json
					// non vengono correttamente mappati, pertanto non si utilizza la funzione
					this.busyProvider.hideBusyIndicator();
					// generica handleError ma si visualizza l'errore cosi' com'e'.
					this.messageProvider.notifyError(error);
			});
    }

	// export delle commesse visualizzate (filtri e ordinamento della tabella) con il dettaglio attivita' di ciascuna
	exportReportStatistiche() {
		if (this.filteredStatistiche.length == 0) {
			return;
		}

		this.messageProvider.clearAll();
		this.busyProvider.showBusyIndicator();

		const parameters = new Object();
		parameters['reforders'] = this.filteredStatistiche.map(s => s.refOrder).join(',');

		this.reportService.exportReport(this.userContext.srmToken, 'com.netsitech.srm.excel.generator.StatisticheReportGenerator', parameters).
			subscribe(
				data => {
					this.busyProvider.hideBusyIndicator();
					let filename = "Report_Statistiche_" + new Date().getTime() + ".xlsx";
					this.download(data, filename);
				},
				error => {
					this.busyProvider.hideBusyIndicator();
					// come per exportReportAttivita: l'errore arriva come blob e non passa da handleError
					this.messageProvider.notifyError(error);
			});
	}

	private download(data: any, filename: string) {
		let blob = new Blob([data], {  type: "application/vnd.ms-excel" });
		FileSaver.saveAs(blob, filename);
	}
}




// WEBPACK FOOTER //
// ./src/app/statistiche/statistiche.component.ts